import {
  getInvoice
} from '@/api/invoice.api'

const state = {
  invoice: {}
}

const mutations = {
  setInvoice (state, invoice) {
    state.invoice = invoice
  }
}

const getters = {
  invoice ({ invoice }) {
    return invoice
  },
  invoiceCourse ({ invoice }) {
    return invoice.purchase ? invoice.purchase.course : {}
  }
}

const actions = {
  async fetchInvoice ({ commit }, id) {
    const invoice = await getInvoice (id)
    commit('setInvoice', invoice)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
